import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AutomaticLoginGuard } from './guards/automatic-login.guard';
import { AngularFireAuthGuard, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';
import { UserGuard } from './guards/user.guard';
import { WildcardRedirectGuard } from './guards/wildcard-redirect.guard';


const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['/home']);


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule),
  },
  {
    path: 'about',
    loadChildren: () => import('./about/about.module').then(m => m.AboutPageModule)
  },
  {
    path: 'contact',
    loadChildren: () => import('./contact/contact.module').then(m => m.ContactPageModule)
  },
  {
    path: 'signin',
    loadChildren: () => import('./init/login/login.module').then(m => m.LoginPageModule),
    canActivate: [AutomaticLoginGuard]
  },
  {
    path: 'signup',
    loadChildren: () => import('./init/signup/signup.module').then(m => m.SignupPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./init/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule)
  },
  {
    path: 'app',
    loadChildren: () => import('./split-pane/split-pane.module').then(m => m.SplitPanePageModule),
    canActivate: [AngularFireAuthGuard, UserGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
    },
  },
  {
    path: 'claim',
    loadChildren: () => import('./devices/claim-device/claim-device.module').then(m => m.ClaimDevicePageModule)
  },
  {
    path: '**', // Wildcard route for undefined URLs
    canActivate: [WildcardRedirectGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
